<script lang="ts">
  import { Icon } from '@shared/ui/icon';

  export let variant: 'primary' | 'secondary' | 'tertiary' = 'primary';

  const styleClasses = {
    primary:
      'bg-teal-50 hover:bg-teal-100 text-teal-800 border-teal-100 dark:text-teal-500 dark:bg-teal-400/20 dark:border-teal-400/10 dark:hover:bg-teal-400/30',
    secondary:
      'bg-violet-50 hover:bg-violet-100 text-violet-800 border-violet-100 dark:text-violet-400 dark:bg-violet-400/20 dark:border-violet-400/10 dark:hover:bg-violet-400/30',
    tertiary:
      'bg-blue-750/10 hover:bg-blue-750/15 text-blue-750 border-blue-750/20 dark:text-blue-650 dark:bg-blue-650/20 dark:border-blue-650/25 dark:hover:bg-blue-650/30',
  };
</script>

<button
  on:click
  class="font-rm inline-flex items-center gap-1.5 rounded-[4px] border px-1.5 py-1.5 text-sm font-medium uppercase transition-colors {styleClasses[
    variant
  ]}"
>
  <Icon name="DO" width="{16}" height="{20}" />
  <slot />
</button>
